import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { INotification } from './notification-service/notification.interface';
import { NotificationService } from './notification-service/notification.service';
import { NotificationTypeEnum } from './notification-service/notification-type.enum';
import { TRADEME_CORE_UI_COMPACT_MAX_WIDTH } from '@classifieds-sell/trademe-core-ui';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'tm-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotificationsComponent implements OnInit, OnDestroy {
    public notificationTypeEnum = NotificationTypeEnum;
    public notifications: Array<INotification> = [];
    public isCompact: boolean;

    private _destroyed$: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _breakpointObserver: BreakpointObserver,
        private _notificationService: NotificationService
    ) {}

    public ngOnInit(): void {
        this._notificationService.notifications$
            .pipe(takeUntil(this._destroyed$))
            .subscribe((notifications: Array<INotification>) => {
                this.notifications = notifications;
                this._changeDetectorRef.markForCheck();
            });

        this._breakpointObserver
          .observe([TRADEME_CORE_UI_COMPACT_MAX_WIDTH])
          .subscribe((result) => {
            this.isSmallChange(result.matches);
          });
    }

    public ngOnDestroy(): void {
        this._destroyed$.next(true);
    }

    public dismiss(notification: INotification): void {
        this._notificationService.dismiss(notification);
    }

    public getType(notification: INotification): string {
        return NotificationTypeEnum[notification.type];
    }

    public onAction = (notification: INotification) => {
        if (notification.action && notification.action.onClick) {
            notification.action.onClick();
        }

        this.dismiss(notification);
    };

    private isSmallChange(isSmall: boolean) {
      this.isCompact = isSmall;
      this._changeDetectorRef.markForCheck();
    }
}
